/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAvailableTimeSlot: () => {
    return axios.get(API_ENDPOINTS.GET_TIME_SLOTS, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  saveAvailableTimeSlot: (data) => {
    return axios.post(API_ENDPOINTS.SAVE_APPOINTMENT, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
}
